import React, { useState } from 'react';
import { feed } from '../../content/site';
import { GoBar } from './GoBar';
import styles from './Apps.module.css';

/** 최근 글을 책등으로 꽂아 둔 책장. 패널 어디를 눌러도 feed로 가고, 책등은 그 글로 간다 */
export const Feed: React.FC = () => {
    const [hoveredTitle, setHoveredTitle] = useState<string | null>(null);

    return (
        <div className={styles.feed}>
            <a className={styles.strip} href={feed.url}>
                <span>책장</span>
                <span>글 {feed.count}편</span>
            </a>
            <div className={styles.shelf}>
                {feed.items.map(({ title, url }) => (
                    <a
                        key={url}
                        className={styles.spine}
                        href={url}
                        title={title}
                        onPointerEnter={() => setHoveredTitle(title)}
                        onPointerLeave={() => setHoveredTitle(null)}
                        onFocus={() => setHoveredTitle(title)}
                        onBlur={() => setHoveredTitle(null)}
                    >
                        <span>{title}</span>
                    </a>
                ))}
            </div>
            <p className={styles.caption}>역사, 과학, 경제, 철학까지. 한 주제를 끝까지 파고든 글.</p>
            <GoBar label={hoveredTitle ? `${hoveredTitle} 읽기` : 'feed.dkdk.me 열기'} />
        </div>
    );
};

export default Feed;
